import SubscriptionBase from '@/views/subscriptions/index.vue';
import SubscriptionHome from '@/views/subscriptions/subscriptionHome/index.vue';
import SubscriptionsSettings from '@/views/subscriptions/subscriptionsSettings/index.vue';
import SubscriptionsSettingsNew from '@/views/subscriptions/subscriptionsSettingsNew/index.vue';
import SubscriptionsOpenWeek from '@/views/subscriptions/subscriptionsOpenWeek/index.vue';
import SubscriptionsGetStarted from '@/views/subscriptions/subscriptionsGetStarted/index.vue';
import MenuConfiguration from '@/views/subscriptions/menuConfiguration/index.vue';
import SubscriptionsOrderProducts from '@/views/subscriptions/subscriptionsOrderProducts/index.vue';
import SubscriptionIngredients from '@/views/subscriptionsClient/subscriptionIngredients/index.vue';
import SubscriptionPlates from '@/views/subscriptionsClient/subscriptionPlates/index.vue';
import subscriptionsDashboard from '@/views/subscriptionsClient/subscriptionsDashboard/index.vue';
import SubscriptionsOrders from '@/views/subscriptionsClient/subscriptionsOrders/index.vue';
import SubscriptionHistory from '@/views/subscriptionsClient/subscriptionsHistory/index.vue';


export default [
  {
    path: '/mi-menu',
    name: 'subscription',
    component: SubscriptionBase,
    redirect: { name: 'subscription_home' },
    children: [
      {
        path: '/mi-menu/inicio',
        name: 'subscription_home',
        component: SubscriptionHome
      },
      {
        path: '/mi-menu/mi-suscripcion',
        name: 'subscriptions_settings',
        component: SubscriptionsSettings
      },
      {
        path: '/mi-menu/welcome',
        name: 'subscriptions_settingsNew',
        component: SubscriptionsSettingsNew
      },
      {
        path: '/mi-menu/ingredients',
        name: 'ingredients',
        component: SubscriptionIngredients
      },
      {
        path: '/mi-menu/platos',
        name: 'ingredients',
        component: SubscriptionPlates
      },
      {
        path: '/mi-menu/mi-plan',
        name: 'subscriptions_openWeek',
        component: SubscriptionsOpenWeek
      },
      {
        path: '/mi-menu/mi-plan/menu/:menu_id/dia/:count_id',
        name: 'openWeek_menuConfiguration',
        component: MenuConfiguration
      },
      {
        path: '/mi-menu/comenzar',
        name: 'subscriptions_getStarted',
        component: SubscriptionsGetStarted
      },
      {
        path: '/mi-menu/orden/:order_id',
        name: 'subscriptions_order',
        component: SubscriptionsOrderProducts
      },
      {
        path: '/mi-menu/mi-dashboard',
        name: 'subscriptions_dashboard',
        component: subscriptionsDashboard
      },
      {
        path: '/mi-menu/mis-pedidos',
        name: 'subscriptions_orders',
        component: SubscriptionsOrders
      },
      {
        path: '/mi-menu/mi-historial',
        name: 'subscriptions_history',
        component: SubscriptionHistory
      }
    ]
  }
];
